<template>
  <vxe-grid
    size="small"
    row-id="shipmentBookingCode"
    border
    resizable
    auto-resize
    show-overflow
    highlight-hover-row
    :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
    :data="displayData"
    :columns="tableColumns"
    :loading="loading"
    :height="tableHeight"
  >
    <template #toolbar_form>
      <slot name="header" />
    </template>

    <template #opt="{ row }">
      <el-tooltip
        :content="$l('INDEX.btn_tips_edit') || '编辑'"
        effect="dark"
        placement="top"
      >
        <i
          class="el-icon-edit tool-btn"
          @click="$emit('edit', { type: 'edit', row })"
        />
      </el-tooltip>

      <el-tooltip
        :content="$l('INDEX.btn_tips_delete') || '删除'"
        effect="dark"
        placement="top"
      >
        <i class="el-icon-delete tool-btn" @click="$emit('remove', row)" />
      </el-tooltip>
    </template>

    <template #bookingTypeNameHeader>
      <filter-content
        :text="$l('form_label_bookingType') || '订舱类型'"
        :items="options.bookingTypeName"
        @filter="(e) => (filters.bookingTypeName = e)"
        submitFilterOnClose
      />
    </template>
    <template #dispatchPortNameHeader>
      <filter-content
        :text="$l('form_label_dispatchPort') || '发运港口'"
        :items="options.dispatchPortName"
        @filter="(e) => (filters.dispatchPortName = e)"
        submitFilterOnClose
      />
    </template>
    <template #destinationPortNameHeader>
      <filter-content
        :text="$l('form_label_destinationPort') || '目的港口'"
        :items="options.destinationPortName"
        @filter="(e) => (filters.destinationPortName = e)"
        submitFilterOnClose
      />
    </template>
    <template #destinationPortFullNameHeader>
      <filter-content
        :text="$l('form_label_deliveryPort') || '指运港'"
        :items="options.destinationPortFullName"
        @filter="(e) => (filters.destinationPortFullName = e)"
        submitFilterOnClose
      />
    </template>
    <template #destinationCountryHeader>
      <filter-content
        :text="$l('form_label_destinationCountry') || '目的国'"
        :items="options.destinationCountry"
        @filter="(e) => (filters.destinationCountry = e)"
        submitFilterOnClose
      />
    </template>
    <template #shipmentTypeNameHeader>
      <filter-content
        :text="$l('table_label_dispatchType') || '出运方式'"
        :items="options.shipmentTypeName"
        @filter="(e) => (filters.shipmentTypeName = e)"
        submitFilterOnClose
      />
    </template>
    <template #quotedMethodNameHeader>
      <filter-content
        :text="$l('form_label_quotedMethod') || '报价方式'"
        :items="options.quotedMethodName"
        @filter="(e) => (filters.quotedMethodName = e)"
        submitFilterOnClose
      />
    </template>
    <template #deliveryDateHeader>
      <filter-content
        :text="$l('table_label_loadingDate') || '产装日期'"
        :items="options.deliveryDate"
        @filter="(e) => (filters.deliveryDate = e)"
        submitFilterOnClose
      />
    </template>
    <template #etaHeader>
      <filter-content
        :text="$l('table_label_eta') || '到港日期'"
        :items="options.eta"
        @filter="(e) => (filters.eta = e)"
        submitFilterOnClose
      />
    </template>
    <template #fbaArrivalDateHeader>
      <filter-content
        :text="$l('form_label_fbaArrivalDate') || '到FBA日期'"
        :items="options.fbaArrivalDate"
        @filter="(e) => (filters.fbaArrivalDate = e)"
        submitFilterOnClose
      />
    </template>
    <template #bookingScmNameHeader>
      <filter-content
        :text="$l('form_label_bookingScmCode') || '订舱货代'"
        :items="options.bookingScmName"
        @filter="(e) => (filters.bookingScmName = e)"
        submitFilterOnClose
      />
    </template>
    <template #customsBrokerScmNameHeader>
      <filter-content
        :text="$l('form_label_customsBrokerScmCode') || '报关货代'"
        :items="options.customsBrokerScmName"
        @filter="(e) => (filters.customsBrokerScmName = e)"
        submitFilterOnClose
      />
    </template>
    <template #domesticTransitNameHeader>
      <filter-content
        :text="$l('form_label_domesticTransitScmCode') || '境内运输公司'"
        :items="options.domesticTransitName"
        @filter="(e) => (filters.domesticTransitName = e)"
        submitFilterOnClose
      />
    </template>
    <template #overseasTransitNameHeader>
      <filter-content
        :text="$l('form_label_overseasTransitScmCode') || '境外运输公司'"
        :items="options.overseasTransitName"
        @filter="(e) => (filters.overseasTransitName = e)"
        submitFilterOnClose
      />
    </template>
    <template #shipperNameHeader>
      <filter-content
        :text="$l('form_label_shipperCode') || '发货人'"
        :items="options.shipperName"
        @filter="(e) => (filters.shipperName = e)"
        submitFilterOnClose
      />
    </template>
    <template #consigneeNameHeader>
      <filter-content
        :text="$l('form_label_consigneeCode') || '收货人'"
        :items="options.consigneeName"
        @filter="(e) => (filters.consigneeName = e)"
        submitFilterOnClose
      />
    </template>
    <template #notifierNameHeader>
      <filter-content
        :text="$l('form_label_notifierCode') || '通知人'"
        :items="options.notifierName"
        @filter="(e) => (filters.notifierName = e)"
        submitFilterOnClose
      />
    </template>
    <template #shipVoyageHeader>
      <filter-content
        :text="$l('form_label_shipVoyage') || '船名航次'"
        :items="options.shipVoyage"
        @filter="(e) => (filters.shipVoyage = e)"
        submitFilterOnClose
      />
    </template>
    <template #bookingDateHeader>
      <filter-content
        :text="$l('form_label_bookingDate') || '订舱日期'"
        :items="options.bookingDate"
        @filter="(e) => (filters.bookingDate = e)"
        submitFilterOnClose
      />
    </template>
  </vxe-grid>
</template>

<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import {
  applyTableFilters,
  buildFilterOptions,
  resetTableFilters,
} from '../table-filter-helpers'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      filters: {
        bookingTypeName: [],
        dispatchPortName: [],
        destinationPortName: [],
        destinationPortFullName: [],
        destinationCountry: [],
        shipmentTypeName: [],
        quotedMethodName: [],
        deliveryDate: [],
        eta: [],
        fbaArrivalDate: [],
        bookingScmName: [],
        customsBrokerScmName: [],
        domesticTransitName: [],
        overseasTransitName: [],
        shipperName: [],
        consigneeName: [],
        notifierName: [],
        shipVoyage: [],
        bookingDate: [],
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    options() {
      return buildFilterOptions(this.tableData, Object.keys(this.filters))
    },
    displayData() {
      return applyTableFilters(this.tableData, this.filters, this.options)
    },
  },
  watch: {
    tableData() {
      this.resetFilters()
    },
  },
  methods: {
    resetFilters() {
      this.filters = resetTableFilters(this.filters)
    },
  },
}
</script>
